import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { deepCloneObject } from '@helpers'
import { EVENT_NAME_OBJECT_MESSAGE } from '@constants'

import { ChangedViewRowsState, DeleteRowsPayload, SetViewRowsPayload } from '../../types'

const initialState: ChangedViewRowsState = {
  objectsWithDirtyRecords: {},
}
const changedViewRows = createSlice({
  name: 'changedViewRows',
  initialState,
  reducers: {
    setViewRows(state, action: PayloadAction<SetViewRowsPayload>) {
      const { changedFields, objectCode, recordId, eventName, viewId } = action.payload
      const { objectsWithDirtyRecords } = state
      const objectByCode = objectsWithDirtyRecords[objectCode]
      const viewById = objectByCode?.[viewId]

      // Инициализируем структуру если её нет
      if (!objectsWithDirtyRecords[objectCode]) {
        objectsWithDirtyRecords[objectCode] = {}
      }

      objectsWithDirtyRecords[objectCode][viewId] = {
        ...viewById,
        [recordId]: eventName === EVENT_NAME_OBJECT_MESSAGE.UPDATE ? changedFields : eventName,
      }
    },
    deleteViewRow(state, action: PayloadAction<DeleteRowsPayload>) {
      const { objectCode, recordId, viewId } = action.payload

      // TODO: structuredClone
      const copyStateObjects = deepCloneObject(state.objectsWithDirtyRecords)

      if (copyStateObjects[objectCode]?.[viewId]) {
        delete copyStateObjects[objectCode][viewId][recordId]

        state.objectsWithDirtyRecords = copyStateObjects
      }
    },
  },
})

export default changedViewRows.reducer
export const { setViewRows, deleteViewRow } = changedViewRows.actions
